// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--ka3Iq","link":"dece2e673c--link--y0DVS","link-area":"dece2e673c--link-area--2IYl3"};